import React from 'react';
import { Card, CardContent } from './ui/card';

const ResponsiveTable = ({ 
  data, 
  columns, 
  renderMobileCard, 
  className = "",
  emptyMessage = "ไม่มีข้อมูล"
}) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <>
      {/* Desktop Table - Hidden on mobile */}
      <div className={`hidden lg:block ${className}`}>
        <div className="overflow-x-auto max-w-full">
          <table className="w-full border-collapse min-w-max">
            <thead>
              <tr className="border-b">
                {columns.map((column, index) => (
                  <th
                    key={index}
                    className={`text-left p-2 font-medium text-xs text-muted-foreground whitespace-nowrap ${
                      column.align === 'right' ? 'text-right' : 
                      column.align === 'center' ? 'text-center' : 'text-left'
                    } ${column.width ? `w-${column.width}` : ''}`}
                  >
                    {column.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={rowIndex} className="border-b hover:bg-muted/50">
                  {columns.map((column, colIndex) => (
                    <td
                      key={colIndex}
                      className={`p-2 text-xs ${
                        column.align === 'right' ? 'text-right' : 
                        column.align === 'center' ? 'text-center' : 'text-left'
                      } ${column.width ? `w-${column.width}` : ''}`}
                    >
                      {column.render ? column.render(row) : row[column.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Cards - Hidden on desktop */}
      <div className="lg:hidden space-y-4">
        {data.map((row, index) => (
          <Card key={index} className="p-4">
            <CardContent className="p-0">
              {renderMobileCard ? renderMobileCard(row) : (
                <div className="space-y-2">
                  {columns.map((column, colIndex) => (
                    <div key={colIndex} className="flex justify-between items-center">
                      <span className="text-sm font-medium text-muted-foreground">
                        {column.header}:
                      </span>
                      <span className="text-sm">
                        {column.render ? column.render(row) : row[column.key]}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
};

export default ResponsiveTable;
